import './edit-branch.dialog.component.scss'
import {Branch} from "../../model/Branch";
import {INgModelController} from "angular";

export class EditBranchDialog {

    static instance = (branch: Branch) => ({
        bindToController: true,
        controllerAs: '$ctrl',
        template: require('./edit-branch.dialog.component.html'),
        controller: [
            '$mdDialog',
            'branch',
            EditBranchDialog
        ],
        locals: {
            branch: branch
        },
        bindings: {
            branch: '='
        }
    });

    public constructor(
        private $mdDialog: angular.material.IDialogService,
        private branch: Branch) {
    }

    public submitBranch = () => {
        this.$mdDialog.show(this.getConfirmDialog())
            .then(() => this.$mdDialog.hide(this.branch),
                () => this.$mdDialog.cancel());
    };

    private getConfirmDialog(): angular.material.IConfirmDialog {
        return this.$mdDialog.confirm()
            .multiple(true)
            .title('Are you sure you want to submit branch with unvalidated address?')
            .textContent('You are about to save your changes. \n' +
                'However, this branch address was not verified. \n' +
                'If you take \'Send Physical Letter\' action, \n' +
                'your sender address will be automatically waterfalled to either brand or corporate address. \n' +
                'You can update your address at any time. \n' +
                'Are you sure you want to proceed?')
            .ok('Yes, I am sure')
            .cancel('No, I changed my  mind');
    }

    public submitBranchDisabled = (form: INgModelController) => {
        return form.$invalid;
    };

    public closeEditBranchDialog = () => {
        this.$mdDialog.cancel();
    };
}